exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","file":"chrome.vue?vue&type=style&index=0&lang=css&","sourceRoot":""}]);

